import { useAuth } from "@/auth/Auth";
import { Button } from "@/components/ui/button";
import Header from "@/layout/Header";
import { useEffect } from "react";
import { Cookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function Screen404() {
  const { t } = useTranslation('screen404');
  const navigate = useNavigate();
  const { authData, token } = useAuth();

  const cookies = new Cookies();

  const mundpayLoginByImp = cookies.get('mundpay_login_by_imp') === 'true';

  const isAuthenticated = !!token && (!!authData || mundpayLoginByImp);

  useEffect(() => {
    if (
      isAuthenticated &&
      (location.pathname === '/login' || location.pathname === '/register')
    ) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, location.pathname, navigate]);

  return (
    <div className='h-screen flex flex-col background404'>
      <Header route={''} text='' hideButton={true} />

      <div className='flex items-center justify-center flex-col flex-1'>
        <div className='w-full max-w-xs text-center space-y-8'>
          <div className='space-y-3'>
            <h1 className='text-5xl font-semibold'>{t('title')}</h1>
            <p className='text-muted-foreground'>{t('description')}</p>
          </div>
          <Button
            variant='secondary'
            onClick={() => {
              if (isAuthenticated) {
                navigate('/dashboard');
              } else {
                navigate('/login');
              }
            }}
          >
            {t('button')}
          </Button>
        </div>
      </div>
    </div>
  );
}
